import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useReplaceMeterStepsStore } from '../../useStepsStore';
import { Button } from '../../../../components/Button/Button';
import { NEW_VALUES_FORM_ID } from './constants';
import { NewValuesStepFooter as messages } from './messages';

export const NewValuesStepFooter: VFC = () => {
  const { setPreviousStep } = useReplaceMeterStepsStore();

  return (
    <>
      <Button block style={{ marginRight: 15 }} onClick={() => setPreviousStep()}>
        <FormattedMessage {...messages.back} />
      </Button>

      <Button key="submit" block form={NEW_VALUES_FORM_ID} htmlType="submit" type="primary">
        <FormattedMessage {...messages.next} />
      </Button>
    </>
  );
};
